import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  Divider,
  Paper,
  IconButton,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Collapse,
  CircularProgress,
} from "@mui/material";
import {
  Close as CloseIcon,
  Search as SearchIcon,
  Edit as EditIcon,
  Print as PrintIcon,
  Map as MapIcon,
  Add as AddIcon,
  Bookmark as BookmarkIcon,
  LocationOn as LocationOnIcon,
  ExpandLess,
  ExpandMore,
  AdsClick as AdsClickIcon,
} from "@mui/icons-material";
import PinDropIcon from "@mui/icons-material/PinDrop";

/** bookmark tool drawer panel */
export default function BookmarkToolPanel(ctx) {
  const {
    bookmarkName,
    setBookmarkName,
    bookmarks,
    handleSaveBookmark,
    handleGoToBookmark,
    handleDeleteBookmark,
    onCloseTool,
  } = ctx;

  return (
                <Box sx={{ p: 2 }}>
                  <Typography
                    variant="h6"
                    sx={{ mb: 2, fontWeight: 600, color: "#1976d2" }}
                  >
                    Bookmarks
                  </Typography>

                  {/* Add Bookmark */}
                  <Box sx={{ mb: 2 }}>
                    <Typography
                      variant="body2"
                      sx={{ mb: 0.5, fontWeight: 500 }}
                    >
                      Bookmark Name
                    </Typography>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder="Enter bookmark name"
                      value={bookmarkName}
                      onChange={(e) => setBookmarkName(e.target.value)}
                      onKeyPress={(e) =>
                        e.key === "Enter" && handleSaveBookmark()
                      }
                      sx={{ mb: 1, bgcolor: "white" }}
                    />
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={handleSaveBookmark}
                      startIcon={<AddIcon />}
                      sx={{
                        bgcolor: "#4caf50",
                        "&:hover": { bgcolor: "#45a049" },
                      }}
                    >
                      Save Current View
                    </Button>
                  </Box>

                  <Divider sx={{ my: 2 }} />

                  {/* Bookmarks List */}
                  <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
                    Saved Bookmarks ({bookmarks.length})
                  </Typography>
                  <Box sx={{ maxHeight: 350, overflow: "auto" }}>
                    {bookmarks.length === 0 ? (
                      <Box sx={{ textAlign: "center", py: 4, color: "#999" }}>
                        <BookmarkIcon
                          sx={{ fontSize: 48, mb: 1, opacity: 0.3 }}
                        />
                        <Typography variant="body2">
                          No bookmarks saved yet
                        </Typography>
                      </Box>
                    ) : (
                      bookmarks.map((bookmark) => (
                        <Paper
                          key={bookmark.id}
                          sx={{
                            p: 1,
                            mb: 1,
                            border: "1px solid #e0e0e0",
                            borderRadius: 1,
                          }}
                        >
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <LocationOnIcon
                              sx={{ mr: 1, color: "#1976d2", fontSize: 20 }}
                            />
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography
                                variant="body2"
                                sx={{ fontSize: 13, fontWeight: 500 }}
                                noWrap
                              >
                                {bookmark.name}
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{ fontSize: 11, color: "#888" }}
                              >
                                {bookmark.date}
                              </Typography>
                            </Box>
                            <IconButton
                              size="small"
                              onClick={() => handleGoToBookmark(bookmark)}
                              sx={{
                                color: "#1976d2",
                                "&:hover": { bgcolor: "#e3f2fd" },
                              }}
                              title="Go to bookmark"
                            >
                              <MapIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                              size="small"
                              onClick={() => handleDeleteBookmark(bookmark.id)}
                              sx={{
                                color: "#f44336",
                                "&:hover": { bgcolor: "#ffebee" },
                              }}
                            >
                              <CloseIcon fontSize="small" />
                            </IconButton>
                          </Box>
                        </Paper>
                      ))
                    )}
                  </Box>

                  <Divider sx={{ my: 2 }} />
                  <Button
                    fullWidth
                    variant="outlined"
                    startIcon={<CloseIcon />}
                    onClick={() => {
                      onCloseTool("bookmark");
                    }}
                    sx={{
                      borderColor: "#f44336",
                      color: "#f44336",
                      "&:hover": { bgcolor: "#ffebee" },
                    }}
                  >
                    Close
                  </Button>
                </Box>
  );
}
